var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('toolbar'),_c('v-main',[_c('router-view')],1),_c('div',{staticStyle:{"padding":"20px 0"}},[_c('img',{staticStyle:{"margin":"0 auto","display":"block"},attrs:{"src":require("@/assets/icon.png"),"width":"20"}}),_c('div',{staticStyle:{"text-align":"center","font-size":"8px"}},[_vm._v("Secure By")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }